import { Zap } from "lucide-react";

const items = [
  "Paragolpes & Carrocería",
  "Motor & Transmisión",
  "Ópticas y Faros LED",
  "Sistemas de Freno",
  "Suspensión y Dirección",
  "Sistemas Eléctricos",
  "Compresores de Aire",
  "Turbos y Escapes",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {items.map((item) => (
      <span key={item} className="flex items-center gap-6 px-6">
        <span className="font-display font-bold uppercase tracking-[0.2em] text-2xl sm:text-3xl text-slate-500 whitespace-nowrap">
          {item}
        </span>
        <Zap className="w-5 h-5 text-brand-orange fill-brand-orange shrink-0" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div className="relative overflow-hidden border-y border-industrial-700/70 bg-industrial-900 py-5" data-testid="marquee-strip">
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);
